__turbopack_context__.v({
  "byLine": "global-error-component-module-scss-module__X6a2WG__byLine",
  "globalError": "global-error-component-module-scss-module__X6a2WG__globalError",
  "icon": "global-error-component-module-scss-module__X6a2WG__icon",
  "main": "global-error-component-module-scss-module__X6a2WG__main",
  "social": "global-error-component-module-scss-module__X6a2WG__social",
  "socialMediaHeadline": "global-error-component-module-scss-module__X6a2WG__socialMediaHeadline",
});
